import { SITE_NAME, SITE_ORIGIN, absolute } from '@/lib/site'
import type { DocMeta } from '@/content/docs.generated'

/*
 * Structured data.
 *
 * The capture shipped none, so this is additive rather than a parity item —
 * but a blog with 17 posts and no Article markup leaves obvious value on the
 * table, and the plan calls for it.
 */
const LOGO = '/media/66fd7eaea30ed321717cb6c1_Singulate-logo.svg'

function Script({ data }: { data: Record<string, unknown> }) {
  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
  )
}

export function OrganizationJsonLd() {
  return (
    <Script
      data={{
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: SITE_NAME,
        url: SITE_ORIGIN,
        logo: absolute(LOGO),
      }}
    />
  )
}

export function ArticleJsonLd({ doc }: { doc: DocMeta }) {
  return (
    <Script
      data={{
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: doc.title,
        description: doc.description || undefined,
        image: absolute(doc.heroImage) || undefined,
        datePublished: doc.date || undefined,
        author: doc.author ? { '@type': 'Person', name: doc.author } : undefined,
        publisher: {
          '@type': 'Organization',
          name: SITE_NAME,
          logo: { '@type': 'ImageObject', url: absolute(LOGO) },
        },
        mainEntityOfPage: absolute(doc.route),
      }}
    />
  )
}

export function BreadcrumbJsonLd({ items }: { items: Array<{ name: string; path: string }> }) {
  return (
    <Script
      data={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((it, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: it.name,
          item: absolute(it.path),
        })),
      }}
    />
  )
}
